import React from "react";
import Flex from "@/components/layout/Flex";
import Visibility from "@/components/shared/Visibility";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { TypographyDescriptionProps } from "../types";
import TypographyP from "./typography-p";

function TypographyDescription({
  as,
  asChild,
  description = "",
  className,
  paragraphClassName,
  ...props
}: TypographyDescriptionProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const raw = Array.isArray(description) ? description : [description];
  const paragraphs = raw.map(p => (p ?? "").trim()).filter(p => p.length > 0);

  return (
    <Visibility shouldShow={paragraphs.length > 0}>
      <Flex.Column fill className={cn(className, classes)} {...native}>
        {paragraphs.map((text, index) => (
          <TypographyP
            as={as}
            asChild={asChild}
            key={`${index}-${text.slice(0, 24)}`}
            className={paragraphClassName}
          >
            {text}
          </TypographyP>
        ))}
      </Flex.Column>
    </Visibility>
  );
}

export default TypographyDescription;
